import { render } from "./RodapeRda.vue?vue&type=template&id=4329a7e8&scoped=true"
import script from "./RodapeRda.vue?vue&type=script&lang=js"
export * from "./RodapeRda.vue?vue&type=script&lang=js"

import "./RodapeRda.vue?vue&type=style&index=0&id=4329a7e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4329a7e8"]])

export default __exports__